import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import InputText from "../../components/forms/elements/InputText";
import TipoEnderecoService from "../../services/TipoEnderecoService";
import CrudForm from "../../components/forms/custom/CrudForm";

class FormTipoEndereco extends CrudForm {

    constructor(props) {
        super(props);

        this.state.model = {
            idTipoEndereco: "",
            nome: ""
        };

        this.state.crud = {
            service: TipoEnderecoService,
            labels: {
                title: 'Tipo de Endereço',
            },
            urlList: '/LstTipoEndereco',
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderFields() {
        return (
            <div className="row mb-3 g-3">
                <InputText label="Código" md={3} value={this.state.model.idTipoEndereco} name="idTipoEndereco" readOnly opcionalLabel={false}/>
                <InputText label="Nome da Tipo de Endereço" autoFocus={true} required md={9} value={this.state.model.nome} name="nome" onChange={this.handleChange} maxLength={100} />
            </div>
        );
    }

    render() {
        return super.render();
    }
}

function With(props) {
    let navigate = useNavigate();
    let params = useParams();
    return <FormTipoEndereco {...props} navigate={navigate} params={params} />
}

export default With